import { Grid, Typography } from "@mui/material";
import React from "react";
import NumberFieldElement from "../ReactHookFormElements/NumberFieldElement";
import TextFieldElement from "../ReactHookFormElements/TextFieldElement";
import DatePickerElement from "../ReactHookFormElements/DatePickerElement";
import MultiSelectElement from "../ReactHookFormElements/MultiSelectElement";

type SelfIssuedReceiptBookingEntryProps = {
  index: number;
};

export default function SelfIssuedReceiptBookingData({ index }: SelfIssuedReceiptBookingEntryProps) {
  const label = `${index + 1}.`;

  return (
    <>
      <Grid size={12}>
        <Typography>Von wem wurde die {label} Zahlung veranlasst?</Typography>
        <TextFieldElement
          name={`bookingData.${index}.paymentReceivedFrom`}
          label={"Zahlung empfangen von"}
          fullWidth
          slotProps={{
            htmlInput: {
              maxLength: 255,
            },
          }}
        />
      </Grid>
      <Grid size={12}>
        <Typography>Wann wurde die {label} Zahlung empfangen?</Typography>
        <DatePickerElement
          name={`bookingData.${index}.bookingDate`}
          label="Datum des Geldeingangs"
          disableFuture={true}
        />
      </Grid>
      <Grid size={12}>
        <Typography>Welchen Betrag hatte der {label} Zahlungseingang?</Typography>
        <NumberFieldElement
          name={`bookingData.${index}.amount`}
          label="Höhe des Geldeingangs"
          fullWidth
          fieldType="money"
          numberType={"float"}
        />
      </Grid>
      <Grid size={12}>
        <Typography>Handelt es sich bei der {label} Zahlung um Fremdgeld?</Typography>
        <MultiSelectElement
          name={`bookingData.${index}.isThirdPartyFunds`}
          label="Fremdgeld?"
          options={[
            { id: "yes", label: "Ja" },
            { id: "no", label: "Nein" },
          ]}
        />
      </Grid>
    </>
  );
}
